<template>
  <div id="profile-provider">
    <v-container fluid class="content-wrapper-full pt-2 pt-md-10 px-4 px-md-16">
      <v-tabs v-model="tab" show-arrows v-if="!firstTime">
        <v-tab>{{ $t('basic') }}</v-tab>
        <v-tab>{{ $t('marketing') }}</v-tab>
        <v-tab>{{ $t('classification') }}</v-tab>
        <v-tab>{{ $t('contact') }}</v-tab>
        <v-tab>{{ $t('location') }}</v-tab>
      </v-tabs>
      <v-row class="mt-2" v-if="!firstTime">
        <v-col cols="12" class="d-flex justify-end">
          <v-btn
            depressed
            large
            rounded
            class="white--text font-weight-bold pl-10 pr-10"
            color="black"
            @click="edit = true"
            v-if="!edit"
          >
            <v-icon>mdi-pencil-outline</v-icon>
            {{ $t('edit') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-tabs-items v-model="tab">
        <v-tab-item :transition="false" :reverse-transition="false" :key="1">
          <v-row>
            <v-col cols="12">
              <provider-basic-info
                :next="false"
                :edit="edit"
                @cancel="edit = false"
              ></provider-basic-info>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item :transition="false" :reverse-transition="false" :key="2">
          <v-row>
            <v-col cols="12">
              <provider-marketing-info
                :next="false"
                :edit="edit"
                @cancel="edit = false"
              ></provider-marketing-info>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item :transition="false" :reverse-transition="false" :key="3">
          <v-row>
            <v-col cols="12">
              <provider-classification-info
                :next="false"
                :edit="edit"
                @cancel="edit = false"
              ></provider-classification-info>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item :transition="false" :reverse-transition="false" :key="4">
          <v-row>
            <v-col cols="12">
              <provider-contact-info
                :next="false"
                :edit="edit"
                @cancel="edit = false"
              ></provider-contact-info>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item :transition="false" :reverse-transition="false" :key="5">
          <v-row>
            <v-col cols="12">
              <provider-location-info
                :next="false"
                :edit="edit"
                @cancel="edit = false"
              ></provider-location-info>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
      <v-divider class="mt-5 mb-5" v-if="providerId"></v-divider>
      <v-row v-if="providerId">
        <v-col cols="12">
          <v-dialog v-model="dialogDelete" width="675">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="danger" class="font-weight-bold" dark rounded v-bind="attrs" v-on="on">
                Delete Provider
              </v-btn>
            </template>

            <v-card
              class="px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-5 rounded-xl secondaryBackground"
            >
              <v-card-title class="pb-3">
                <v-row>
                  <v-col sm="12" class="justify-center d-flex">
                    <img
                      alt="Logo"
                      width="180"
                      class="rounded-0 text-center"
                      :src="require('@/assets/svg/logo.svg')"
                    />
                  </v-col>
                </v-row>
                <v-btn icon @click="dialogDelete = false" left>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider class="pb-2"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="justify-center d-flex">
                    <img
                      alt="Delete Logo"
                      class="rounded-0 text-center"
                      :src="require('@/assets/svg/delete.svg')"
                    />
                  </v-col>
                  <v-col cols="12" class="justify-center d-flex">
                    <h3>Delete provider?</h3>
                  </v-col>
                  <v-col cols="12" class="justify-center d-flex">
                    <p class="text-center px-16">
                      Are you sure you want to permanently delete your provider? This action
                      <b>cannot be undone.</b>
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row style="width: 100%">
                  <v-col cols="6">
                    <v-btn
                      block
                      depressed
                      rounded
                      large
                      class="neutral800--text font-weight-bold"
                      color="neutral"
                      outlined
                      @click="dialogDelete = false"
                      >{{ $t('cancel') }}
                    </v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn
                      block
                      depressed
                      rounded
                      large
                      class="white--text font-weight-bold"
                      color="danger"
                      @click="deleteProvider"
                      >{{ $t('delete.message') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import service from '@/services/base-service';
import profile from '@/services/profile-service';
import ProviderClassificationInfo from '@/components/provider-settings/ProviderClassificationInfo';
import ProviderContactInfo from '@/components/provider-settings/ProviderContactInfo';
import ProviderLocationInfo from '@/components/provider-settings/ProviderLocationInfo';
import ProviderMarketingInfo from '@/components/provider-settings/ProviderMarketingInfo';
import ProviderBasicInfo from '@/components/provider-settings/ProviderBasicInfo';
import EventBus from '@/helpers/event-bus';

export default {
  name: 'ProfileProvider',
  components: {
    ProviderClassificationInfo,
    ProviderContactInfo,
    ProviderLocationInfo,
    ProviderMarketingInfo,
    ProviderBasicInfo,
  },
  mixins: [util, service, profile],
  data() {
    return {
      tab: null,
      edit: false,
      firstTime: true,
      dialogDelete: false,
      providerId: null,
    };
  },
  mounted() {
    this.firstTime = this.isFirstTime();
    this.providerId = sessionStorage.getItem('providerId');
  },
  methods: {
    deleteProvider() {
      EventBus.$emit('waiting', true);
      this.axios
        .post('/api/v1/providers/disable/' + this.providerId)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('Your provider has deleted successfully.'),
          });
          this.$router.push({ name: 'Dashboard' }).then(() => {
            this.$router.go();
          });
        })
        .catch(error => {
          console.log(error);
          EventBus.$emit('snackbar', {
            text: 'Something went wrong. Please try again later',
            color: 'error',
          });
        })
        .finally(EventBus.$emit('waiting', false));
    },
  },
};
</script>
